import { ATTRIBUTION_FIELDS } from '../interfaces/attribution.interface';
import moment from 'moment';
import { BookingRequestModel } from '../models/booking-request.model';
import { BookingRequestUiModel } from '../ui-models/booking-request.ui-model';

function mapToUI(bookingRequestData: BookingRequestModel): BookingRequestUiModel {
  return {
    requestId: bookingRequestData.id,
    otp: bookingRequestData.otp,
    status: bookingRequestData.status,
    bookedAt: bookingRequestData.bookedAt,
    screenedAt: bookingRequestData.screenedAt,
    reservationId: bookingRequestData.reservationID,
    guestId: bookingRequestData.guestID,
    availableRooms: bookingRequestData.availableRooms,
    messagesList: bookingRequestData.messagesList,
    area: bookingRequestData.area,
    areaId: bookingRequestData.areaId,
    propertyName: bookingRequestData.propertyName,
    bookingInfo: {
      checkInDate: bookingRequestData.checkInDate,
      checkOutDate: bookingRequestData.checkOutDate,
      numberOfGuests: bookingRequestData.numberOfGuests,
      unitTypeId: bookingRequestData.unitTypeId
    },
    guestInfo: {
      email: bookingRequestData.email,
      gender: bookingRequestData.gender,
      moreInfo: bookingRequestData.moreInfo,
      name: bookingRequestData.name,
      phoneNumber: bookingRequestData.phoneNumber,
      socialLink: bookingRequestData.socialLink
    },
    offerInfo: {
      oneTime: bookingRequestData.oneTimePayment,
      recurring: bookingRequestData.recurringPayment
    },
    source: bookingRequestData.source,
    channel: bookingRequestData.channel,
    // Copied off the field list rather than named individually: this mapper is
    // the only path from API shape to view shape, so a field missed here is
    // invisible in the admin no matter what the database holds.
    ...ATTRIBUTION_FIELDS.reduce((acc: Record<string, unknown>, field) => {
      const value = (bookingRequestData as unknown as Record<string, unknown>)[field];
      if (value !== undefined && value !== null && value !== '') acc[field] = value;
      return acc;
    }, {}),
    age: bookingRequestData.age,
    nationality: bookingRequestData.nationality,
    interestedBedrooms: bookingRequestData.interestedBedrooms,
    specialRequest: bookingRequestData.specialRequest,
    budgetFrom: bookingRequestData.budgetFrom,
    budgetTo: bookingRequestData.budgetTo,
    interestedLocation: bookingRequestData.interestedLocation,
    interestedProject: bookingRequestData.interestedProject,
    noResponseFirstContactedAt: bookingRequestData.noResponseFirstContactedAt?.time,
    noResponseSecondContactedAt: bookingRequestData.noResponseSecondContactedAt?.time,
    noResponseThirdContactedAt: bookingRequestData.noResponseThirdContactedAt?.time,
    missingDetailsFirstContactedAt: bookingRequestData.missingDetailsFirstContactedAt?.time,
    missingDetailsSecondContactedAt: bookingRequestData.missingDetailsSecondContactedAt?.time,
    missingDetailsThirdContactedAt: bookingRequestData.missingDetailsThirdContactedAt?.time,
    noResponseContactedBy: {
      firstContactedBy: bookingRequestData?.noResponseFirstContactedAt?.actionTakenByName,
      secondContactedBy: bookingRequestData?.noResponseSecondContactedAt?.actionTakenByName,
      thirdContactedBy: bookingRequestData?.noResponseThirdContactedAt?.actionTakenByName
    },
    missingDetailsContactedBy: {
      firstContactedBy: bookingRequestData?.missingDetailsFirstContactedAt?.actionTakenByName,
      secondContactedBy: bookingRequestData?.missingDetailsSecondContactedAt?.actionTakenByName,
      thirdContactedBy: bookingRequestData?.missingDetailsThirdContactedAt?.actionTakenByName
    }
  };
}

function mapToUIList(bookingRequestsList: BookingRequestModel[]): BookingRequestUiModel[] {
  return bookingRequestsList.map(mapToUI);
}

export default {
  mapToUI,
  mapToUIList
};
